export default "{\n    \"title\": \"Détails de l'entretien planifié\",\n    \"breadcrumbsParentLinkText\": \"Entretien planifié\"\n}\n"